import styled from 'styled-components';

import { Logo } from '../../atoms/logo/logo';

const Panel = styled.aside`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 56px 56px 48px;
  background: ${({ theme }) => theme.colors.brandGradient};
  color: #ffffff;
  isolation: isolate;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 44px 40px 36px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 28px 24px 32px;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.16) 0%,
      rgba(255, 255, 255, 0) 70%
    );
    z-index: -1;
    pointer-events: none;
  }

  &::before {
    width: 520px;
    height: 520px;
    top: -180px;
    right: -200px;
  }

  &::after {
    width: 380px;
    height: 380px;
    bottom: -120px;
    left: -120px;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 70%
    );
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(6px);
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: 500;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 460px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

const Eyebrow = styled.span`
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.78);
`;

const Headline = styled.h1`
  font-size: clamp(28px, 3vw, 38px);
  line-height: 1.15;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.02em;
`;

const Lede = styled.p`
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 15px;
  line-height: 1.6;
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

const Bullet = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
  }
`;

export const BrandPanel = () => (
  <Panel>
    <Top>
      <Logo variant="light" size={22} />
      <Pill aria-hidden="true">
        <span>Backoffice</span>
      </Pill>
    </Top>

    <Center>
      <Eyebrow>Plataforma de Gestão</Eyebrow>
      <Headline>
        Operar a Vendepay com clareza, controle e velocidade.
      </Headline>
      <Lede>
        Um cockpit único para o time interno acompanhar clientes, transações e
        operações em tempo real.
      </Lede>
    </Center>

    <Bottom>
      <span>© Vendepay {new Date().getFullYear()}</span>
      <div style={{ display: 'flex', gap: 16 }}>
        <Bullet>Seguro</Bullet>
        <Bullet>Auditado</Bullet>
        <Bullet>Tempo real</Bullet>
      </div>
    </Bottom>
  </Panel>
);
